import type { CmpHider } from './types';

export const ccc: CmpHider = {
  id: 'ccc',
  label: 'CCC',
  css: `
      #ccc,
      #ccc-overlay,
      #ccc-notify { display: none !important; }
  `,
};
